import { localstorageGet } from '@/helpers/helper';
import axios from 'axios';
import { clearSession, getSession } from '@/indexedDB';

const APP_BASE_URL = 'https://back-end.mad-dev.pp.ua/api';

const axiosClient = axios.create();
axiosClient.interceptors.request.use(
  async (config: any) => {
    const db = await getSession('user');
    config.headers = {
      Authorization: `Bearer ${db?.token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    config.baseURL = APP_BASE_URL;
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  function (response: any) {
    return response;
  },
  async function (error: any) {
    if (error.response.status && error.response.status === 401) {
      if (!error.response.config.url.includes('api/login')) {
        await clearSession();
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
